import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useRef, useState } from 'react'
import ReportHeader from '../component/report-header/ReportHeader'
import AHMIS, { API_URL } from '../../../api/api';
import { ERROR, REPORT_NOT_DRAWN, SOMETHING_WENT_WRONG, SUCCESS } from '../../../utils/constants';
import AddAlertMessage from '../../../components/alert/Alert';
import MessageBlock from '../../admin/components/message-block/MessageBlock';

const NcdReport = () => {
  const [tableData, setTableData] = useState();
  const printComponentRef = useRef();

  const getReportData = (dateFrom, dateTo) => {
    const url = `${API_URL.ncdReport}?fromDate=${dateFrom}&toDate=${dateTo}`;
    AHMIS.get(url)
      .then(response => {
        const jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setTableData(jsondata.data);
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: `${SOMETHING_WENT_WRONG}: ${error.message}` });
      });
  };

  return (
    <>
      <ReportHeader title="अकुपञ्चर सेवा प्रतिवेदन"
        getReportData={getReportData}
        reportData={Boolean(tableData)}
        printComponentRef={printComponentRef}
      />
      {tableData ? (
        <Box ref={printComponentRef}>
          <TableContainer classes={{ root: "fixed-head-table-container" }}  >
            <Typography variant="body1" className="report-heading">नसर्ने रोगको  प्रतिबेदन </Typography>
            <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="NCD-Sewa-Report">
              <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
                <TableRow>
                  <TableCell rowSpan={2}>सेवाको प्रकार अनुसार सेवा लिएको विवरण</TableCell>
                  <TableCell colSpan={3}>मनोसामाजिक सेवा</TableCell>
                  <TableCell colSpan={3}>परामर्श सेवा</TableCell>
                  <TableCell colSpan={3}>औषधी</TableCell>
                  <TableCell colSpan={3}>अन्य</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>महिला</TableCell>
                  <TableCell>पुरूष</TableCell>
                  <TableCell>अन्य</TableCell>
                  <TableCell>महिला</TableCell>
                  <TableCell>पुरूष</TableCell>
                  <TableCell>अन्य</TableCell>
                  <TableCell>महिला</TableCell>
                  <TableCell>पुरूष</TableCell>
                  <TableCell>अन्य</TableCell>
                  <TableCell>महिला</TableCell>
                  <TableCell>पुरूष</TableCell>
                  <TableCell>अन्य</TableCell>
                </TableRow>
              </TableHead>
              <TableBody classes={{ root: "align-center" }}>
                <TableRow>
                  <TableCell>नसर्ने रोगी</TableCell>
                  <TableCell>{tableData?.report?.NON_COMMUNICABLE_DISEASE?.mentalConsultation?.FEMALE}</TableCell>
                  <TableCell>{tableData?.report?.NON_COMMUNICABLE_DISEASE?.mentalConsultation?.MALE}</TableCell>
                  <TableCell>{tableData?.report?.NON_COMMUNICABLE_DISEASE?.mentalConsultation?.OTHER}</TableCell>
                  <TableCell>{tableData?.report?.NON_COMMUNICABLE_DISEASE?.paramarsa?.FEMALE}</TableCell>
                  <TableCell>{tableData?.report?.NON_COMMUNICABLE_DISEASE?.paramarsa?.MALE}</TableCell>
                  <TableCell>{tableData?.report?.NON_COMMUNICABLE_DISEASE?.paramarsa?.OTHER}</TableCell>
                  <TableCell>{tableData?.report?.NON_COMMUNICABLE_DISEASE?.medicine?.FEMALE}</TableCell>
                  <TableCell>{tableData?.report?.NON_COMMUNICABLE_DISEASE?.medicine?.MALE}</TableCell>
                  <TableCell>{tableData?.report?.NON_COMMUNICABLE_DISEASE?.medicine?.OTHER}</TableCell>
                  <TableCell>{tableData?.report?.NON_COMMUNICABLE_DISEASE?.others?.FEMALE}</TableCell>
                  <TableCell>{tableData?.report?.NON_COMMUNICABLE_DISEASE?.others?.MALE}</TableCell>
                  <TableCell>{tableData?.report?.NON_COMMUNICABLE_DISEASE?.others?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>मानसिक रोगी</TableCell>
                  <TableCell>{tableData?.report?.MENTAL_HEALTH?.mentalConsultation?.FEMALE}</TableCell>
                  <TableCell>{tableData?.report?.MENTAL_HEALTH?.mentalConsultation?.MALE}</TableCell>
                  <TableCell>{tableData?.report?.MENTAL_HEALTH?.mentalConsultation?.OTHER}</TableCell>
                  <TableCell>{tableData?.report?.MENTAL_HEALTH?.paramarsa?.FEMALE}</TableCell>
                  <TableCell>{tableData?.report?.MENTAL_HEALTH?.paramarsa?.MALE}</TableCell>
                  <TableCell>{tableData?.report?.MENTAL_HEALTH?.paramarsa?.OTHER}</TableCell>
                  <TableCell>{tableData?.report?.MENTAL_HEALTH?.medicine?.FEMALE}</TableCell>
                  <TableCell>{tableData?.report?.MENTAL_HEALTH?.medicine?.MALE}</TableCell>
                  <TableCell>{tableData?.report?.MENTAL_HEALTH?.medicine?.OTHER}</TableCell>
                  <TableCell>{tableData?.report?.MENTAL_HEALTH?.others?.FEMALE}</TableCell>
                  <TableCell>{tableData?.report?.MENTAL_HEALTH?.others?.MALE}</TableCell>
                  <TableCell>{tableData?.report?.MENTAL_HEALTH?.others?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>चोट लागेको</TableCell>
                  <TableCell>{tableData?.report?.INJURY?.mentalConsultation?.FEMALE}</TableCell>
                  <TableCell>{tableData?.report?.INJURY?.mentalConsultation?.MALE}</TableCell>
                  <TableCell>{tableData?.report?.INJURY?.mentalConsultation?.OTHER}</TableCell>
                  <TableCell>{tableData?.report?.INJURY?.paramarsa?.FEMALE}</TableCell>
                  <TableCell>{tableData?.report?.INJURY?.paramarsa?.MALE}</TableCell>
                  <TableCell>{tableData?.report?.INJURY?.paramarsa?.OTHER}</TableCell>
                  <TableCell>{tableData?.report?.INJURY?.medicine?.FEMALE}</TableCell>
                  <TableCell>{tableData?.report?.INJURY?.medicine?.MALE}</TableCell>
                  <TableCell>{tableData?.report?.INJURY?.medicine?.OTHER}</TableCell>
                  <TableCell>{tableData?.report?.INJURY?.others?.FEMALE}</TableCell>
                  <TableCell>{tableData?.report?.INJURY?.others?.MALE}</TableCell>
                  <TableCell>{tableData?.report?.INJURY?.others?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>असक्षमता भएको</TableCell>
                  <TableCell>{tableData?.report?.DISABILITY?.mentalConsultation?.FEMALE}</TableCell>
                  <TableCell>{tableData?.report?.DISABILITY?.mentalConsultation?.MALE}</TableCell>
                  <TableCell>{tableData?.report?.DISABILITY?.mentalConsultation?.OTHER}</TableCell>
                  <TableCell>{tableData?.report?.DISABILITY?.paramarsa?.FEMALE}</TableCell>
                  <TableCell>{tableData?.report?.DISABILITY?.paramarsa?.MALE}</TableCell>
                  <TableCell>{tableData?.report?.DISABILITY?.paramarsa?.OTHER}</TableCell>
                  <TableCell>{tableData?.report?.DISABILITY?.medicine?.FEMALE}</TableCell>
                  <TableCell>{tableData?.report?.DISABILITY?.medicine?.MALE}</TableCell>
                  <TableCell>{tableData?.report?.DISABILITY?.medicine?.OTHER}</TableCell>
                  <TableCell>{tableData?.report?.DISABILITY?.others?.FEMALE}</TableCell>
                  <TableCell>{tableData?.report?.DISABILITY?.others?.MALE}</TableCell>
                  <TableCell>{tableData?.report?.DISABILITY?.others?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>जम्मा</TableCell>
                  <TableCell>{tableData?.totalMap?.mentalConsultation?.FEMALE}</TableCell>
                  <TableCell>{tableData?.totalMap?.mentalConsultation?.MALE}</TableCell>
                  <TableCell>{tableData?.totalMap?.mentalConsultation?.OTHER}</TableCell>
                  <TableCell>{tableData?.totalMap?.paramarsa?.FEMALE}</TableCell>
                  <TableCell>{tableData?.totalMap?.paramarsa?.MALE}</TableCell>
                  <TableCell>{tableData?.totalMap?.paramarsa?.OTHER}</TableCell>
                  <TableCell>{tableData?.totalMap?.medicine?.FEMALE}</TableCell>
                  <TableCell>{tableData?.totalMap?.medicine?.MALE}</TableCell>
                  <TableCell>{tableData?.totalMap?.medicine?.OTHER}</TableCell>
                  <TableCell>{tableData?.totalMap?.others?.FEMALE}</TableCell>
                  <TableCell>{tableData?.totalMap?.others?.MALE}</TableCell>
                  <TableCell>{tableData?.totalMap?.others?.OTHER}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        <MessageBlock text={REPORT_NOT_DRAWN} />
      )}
    </>
  )
}

export default NcdReport
